import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { Menu, MenuItem } from '../../components/Menu';
import { usePermission } from '../../hooks/usePermission';
import { useLoading } from '../../units/loading';
import { usePartner } from '../../hooks/usePartner';

type ServiceActionPageProps = {};

ServiceActionPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function ServiceActionPage(props: ServiceActionPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { setIsLoading } = useLoading();
    const { permission, isLoading: isPermissionLoading } = usePermission();
    const { isLoading: isPartnerLoading } = usePartner();

    useEffect(() => {
        setIsLoading(isPermissionLoading || isPartnerLoading);
    }, [permission, isPermissionLoading, isPartnerLoading]);

    return (
        <Page>
            <BackAppBar
                title="專屬服務"
                onBackClick={() => history.replace('/memberService/action')}
            />
            <PageBody maxWidth="lg">
                <Menu>
                    {permission?.product_list ? (
                        <MenuItem
                            text="產品列表"
                            onClick={() => history.push('/product/list')}
                        />
                    ) : null}
                    {permission?.repair_resume ? (
                        <MenuItem
                            text="維修履歷"
                            onClick={() => history.push('/repair/history')}
                        />
                    ) : null}
                </Menu>
            </PageBody>
        </Page>
    );
}

export { ServiceActionPage };
